import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => {
  return {
    AgentWalletHistoryComponentContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      minHeight: '90vh',
    },
    AgentWalletHistoryComponentWraper: {
      padding: '0 32px',
    },
    historyTimelineItemContent: {
      overflow: 'hidden',
    },
    containerTimelinePrefixContent: {
      minWidth: '60px',
      marginInlineEnd: '12px',
      marginBottom: '15px',
    },
    dayTitle: {
      fontSize: '18px',
      fontWeight: '500',
      lineHeight: '28px',
      color: theme.palette.foreground.senary,
    },
    yearTitle: {
      fontSize: '20px',
      fontWeight: '700',
      lineHeight: '30px',
      color: theme.palette.foreground.senary,
    },
    timeTitle: {
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '20px',
      color: theme.palette.foreground.senary,
    },
    wrapperHistoryTimelineItemContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      padding: '12px 0px 12px 24px',
      width: '100%',
      marginBottom: '10px',

      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    HistoryTimelineItemContent: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    containerHistoryInformation: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    containerHeaderHistory: {
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      alignItems: 'center',
    },
    containerTypeHistory: {
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      alignItems: 'center',
    },
    containerImage: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: `1px solid rgba(0, 0, 0, 0.08)`,
      borderRadius: '99999px',
    },
    imageWrapper: {
      height: '24px',
      width: '24px',
      borderRadius: '99999px',
    },
    createdByTitle: {
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '24px',
      color: theme.palette.text.secondary,
    },
    typeValue: {
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '20px',
      color: theme.palette.text.primary,
    },
    typeTitle: {
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '20px',
      color: theme.palette.text.tertiary,
    },
    containerTableContactFieldChange: {
      width: '100%',
      border: `1px solid rgba(0, 0, 0, 0.08)`,
      borderRadius: '12px',

      [theme.breakpoints.down('sm')]: {
        maxWidth: '55vw',
        overflowX: 'scroll',
      },
    },
    headerTable: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      minWidth: '70px',
      backgroundColor: theme.palette.background.secondary,
      textAlign: 'center',
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
      height: '44px',
    },
    bodyTable: {
      display: 'flex',
      flexDirection: 'row',
      height: '52px',
      borderBottom: `1px solid rgba(0, 0, 0, 0.08)`,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    tableCellTitle: {
      flex: '1',
      minWidth: '70px',
      textAlign: 'center',
      padding: '12px 24px',
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'stretch',
      '&:first-child': {
        minWidth: '165px',
      },
    },
    tableCellTitleBlank: {
      minWidth: '5px',
    },
    tableCellValue: {
      flex: '1',
      minWidth: '70px',
      textAlign: 'center',
      color: theme.palette.text.primary,
      fontWeight: '500',
      display: 'flex',
      padding: '16px 24px',
      alignItems: 'center',
      alignSelf: 'stretch',
      overflowX: 'auto',
      overflowY: 'hidden',
    },
    tableCellTitleField: {
      flex: '1',
      minWidth: '165px',
      textAlign: 'center',
      fontWeight: '400',
      color: theme.palette.text.tertiary,
      lineHeight: '20px',
      display: 'flex',
      height: '52px',
      padding: '16px 16px',
      alignItems: 'center',
      alignSelf: 'stretch',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
    },
    iconWrapper: {
      display: 'flex',
      height: '52px',
      padding: '16px 8px',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'stretch',
    },
    loaderContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '80vh',
    },
  };
});
